import type { ContentSubmission } from "@/marketing/models/campaignInfluencer";

export interface ContentPostItem {
  url: string;
  sparkAdsCode?: string | undefined;
}

function contentIdentity(rawUrl: string): string {
  try {
    const url = new URL(rawUrl);
    const host = url.hostname.replace(/^www\./, "").toLowerCase();
    if (host === "tiktok.com" || host === "m.tiktok.com") {
      const post = url.pathname.match(/^\/@[^/]+\/video\/(\d+)\/?$/);
      if (post) return `tiktok:${post[1]}`;
    }
    if (host === "instagram.com") {
      const post = url.pathname.match(/^\/(?:p|reel|tv)\/([A-Za-z0-9_-]+)\/?$/);
      if (post) return `instagram:${post[1]}`;
    }
  } catch {
    // Preserve unrecognized legacy URLs without guessing their provider identity.
  }
  return rawUrl;
}

// Structured metadata wins for the same video; unrelated legacy links remain visible.
export function toContentPostItems(
  submissions: ContentSubmission[] | undefined,
  urls: string[] | undefined,
): ContentPostItem[] {
  const items: ContentPostItem[] = [];
  const seen = new Set<string>();
  for (const item of [
    ...(submissions ?? []).map((submission) => ({ url: submission.url, sparkAdsCode: submission.sparkAdsCode })),
    ...(urls ?? []).map((url) => ({ url })),
  ]) {
    const identity = contentIdentity(item.url);
    if (seen.has(identity)) continue;
    seen.add(identity);
    items.push(item);
  }
  return items;
}
